import { render, staticRenderFns } from "./inquiry-transaction.vue?vue&type=template&id=5028628f&scoped=true"
import script from "./inquiry-transaction.vue?vue&type=script&lang=js"
export * from "./inquiry-transaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028628f",
  null
  
)

export default component.exports